<template>
  <v-container class="page-container p-3">
    <WarehouseConfigDetailContainer />
  </v-container>
</template>

<script>
import WarehouseConfigDetailContainer from "@/components/Container/WarehouseConfigDetailContainer.vue"
export default {
  components: { WarehouseConfigDetailContainer },
}
</script>
